import {
  PossibleBooleanValues,
  UserProfileCustomField
} from '@features/member-management/types';
import { BloodGroups } from '@types';

export const getDefaultUserProfileTemplateHeaders = (
  defaultTemplateHeaders: string[],
  customFields: UserProfileCustomField[]
) => {
  const templateHeaders = [...defaultTemplateHeaders];
  if (customFields) {
    customFields.forEach((field) => {
      templateHeaders.push(field.label);
    });
  }

  return templateHeaders;
};

export const getUserProfileDefaultValue = (fieldKey: string) => {
  switch (fieldKey) {
    case 'is_insured':
      return PossibleBooleanValues.NO;
    case 'blood_group':
      return BloodGroups.A_POSITIVE;
    case 'counsellor_name':
      return 'Jane Doe';
    default: {
      return '';
    }
  }
};

export const getTemplateUserProfileDummayData = (
  userProfileDummyData: string[],
  customFields: UserProfileCustomField[]
) => {
  const templateDummayData = [...userProfileDummyData];

  if (customFields) {
    customFields.forEach((field) => {
      const defaultValue = getUserProfileDefaultValue(field.key);
      templateDummayData.push(defaultValue);
    });
  }

  return templateDummayData;
};

export const getRequiredCustomFieldHeaders = (
  customFields: UserProfileCustomField[]
): string[] =>
  (customFields || []).filter((f) => f.is_required).map((f) => f.label);

export const getRequiredCustomFieldDummyData = (
  customFields: UserProfileCustomField[]
): string[] =>
  (customFields || [])
    .filter((f) => f.is_required)
    .map((f) => getUserProfileDefaultValue(f.key));
